/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeAIcon16Light } from './MediaAudioVolumeAIcon16Light';
import { MediaAudioVolumeAIcon16Regular } from './MediaAudioVolumeAIcon16Regular';
import { MediaAudioVolumeAIcon16Solid } from './MediaAudioVolumeAIcon16Solid';
import { MediaAudioVolumeAIcon20Light } from './MediaAudioVolumeAIcon20Light';
import { MediaAudioVolumeAIcon20Regular } from './MediaAudioVolumeAIcon20Regular';
import { MediaAudioVolumeAIcon20Solid } from './MediaAudioVolumeAIcon20Solid';
import { MediaAudioVolumeAIcon24Regular } from './MediaAudioVolumeAIcon24Regular';
import { MediaAudioVolumeAIcon24Solid } from './MediaAudioVolumeAIcon24Solid';
import { MediaAudioVolumeAIcon32Regular } from './MediaAudioVolumeAIcon32Regular';
import { MediaAudioVolumeAIcon64Regular } from './MediaAudioVolumeAIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeAIcon16Light,
        regular: MediaAudioVolumeAIcon16Regular,
        solid: MediaAudioVolumeAIcon16Solid,
    },
    20: {
        light: MediaAudioVolumeAIcon20Light,
        regular: MediaAudioVolumeAIcon20Regular,
        solid: MediaAudioVolumeAIcon20Solid,
    },
    24: {
        regular: MediaAudioVolumeAIcon24Regular,
        solid: MediaAudioVolumeAIcon24Solid,
    },
    32: {
        regular: MediaAudioVolumeAIcon32Regular,
    },
    64: {
        regular: MediaAudioVolumeAIcon64Regular,
    },
};
export var MediaAudioVolumeAIcon = forwardRef('MediaAudioVolumeAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
